import { render, staticRenderFns } from "./NewsSummary.vue?vue&type=template&id=48ef77e3"
import script from "./NewsSummary.ts?vue&type=script&lang=ts&external"
export * from "./NewsSummary.ts?vue&type=script&lang=ts&external"
import style0 from "./NewsSummary.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports